export enum PotentialTerminationReasonList {
  NoLongerContracted = 1,
  Retired = 2,
  Deceased = 3,
  NoLongerAssociated = 4,
  InvitationSentToOutdatedContact = 5,
  Other = 6,
  FacilityClosed = 8,
}
